const Packer = require('pypacker');
const crypto = require('crypto');
const zlib = require('zlib');
const Buffer = require('buffer').Buffer;

const ESP32ROM = {
    BOOTLOADER_FLASH_OFFSET: 0x1000,
    FLASH_SIZES: {
        '1MB': 0x00,
        '2MB': 0x10,
        '4MB': 0x20,
        '8MB': 0x30,
        '16MB': 0x40
    },
    STUB_CODE: {
        data_start: 1073736612,
        data: Buffer.from('08c0fe3f', 'hex'),
        text: Buffer.from('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', 'hex'),
        text_start: 1074393088,
        entry: 1074394468
    }
};

const ESP_IMAGE_MAGIC = 0xe9;
const FLASH_WRITE_SIZE = 0x4000;
const DEFAULT_TIMEOUT = 3;
const MD5_TIMEOUT_PER_MB = 8;
const ERASE_REGION_TIMEOUT_PER_MB = 30;
const ESP_FLASH_DEFL_BEGIN = 0x10;

const ESP_FLASH_DEFL_DATA = 0x11;
const ESP_SYNC = 0x08;
const SYNC_TIMEOUT = 0.1;

const ESP_CHECKSUM_MAGIC = 0xef;
const ESP_SPI_FLASH_MD5 = 0x13;
const ESP_FLASH_DEFL_END = 0x12;
const ESP_FLASH_BEGIN = 0x02;
const ESP_MEM_BEGIN = 0x05;
const ESP_MEM_END = 0x06;
const ESP_MEM_DATA = 0x07;
const ESP_RAM_BLOCK = 0x1800;
const FLASH_SIZE = '4MB';

const Flash_Size_Bytes = (size) => {
    if (-1 < size.indexOf('MB')) {
        return parseInt(size.substring(0, size.indexOf('MB'))) * 1024 * 1024;
    } else if (-1 < size.indexOf('KB')) {
        return parseInt(size.substring(0, size.indexOf('KB'))) * 1024;
    } else {
        throw new Error('Unknown size ' + size);
    }
};

// 缓冲池
class BufferPool {
    constructor() {
        this.init();
    }

    // 初始化缓冲池
    init() {
        this.buf = [];
        this.temp = [];
    }

    /**
     * 串口回调数据写入缓冲区
     * @param b arraybuffer
     * @returns {boolean}
     */
    write(b) {
        const fsize = Flash_Size_Bytes(FLASH_SIZE);
        if (this.temp.length > fsize) {
            throw new Error('缓冲区大小超过固件限制额度。');
        }
        b.forEach((v, k) => {
            this.temp.push(v);
        });
        this.slip_write();
        return true;
    }

    /**
     * 读取解析后的串口缓冲区数据
     * @returns arraybuffer
     */
    read() {
        let b = [];
        if (this.buf.length > 0) {
            b = this.buf.shift();
        }
        return Buffer.from(b);
    }

    /**
     * 写入的缓冲区的数据进行解析
     */
    slip_write() {
        let in_escape = false;
        let partial_packet = null;
        let b, i = 0;
        while (0 < this.temp.length) {
            if (i === this.temp.length) {
                break;
            }
            b = this.temp[i];
            if (partial_packet === null) {
                if (b === 0xc0) {
                    partial_packet = [];
                } else {
                    this.temp.splice(0, i + 1);
                    i = 0;
                    continue;
                }
            } else if (in_escape) {
                in_escape = false;
                if (b === 0xdc) {
                    partial_packet.push(0xc0);
                } else if (b === 0xdd) {
                    partial_packet.push(0xdb);
                } else {
                    this.temp.splice(0, i + 1);
                    i = 0;
                    continue;
                }
            } else if (b === 0xdb) {
                in_escape = true
            } else if (b === 0xc0) {
                this.temp.splice(0, i + 1);
                i = 0;
                this.buf.push(partial_packet);
                if (partial_packet.length !== 0) {
                    partial_packet = null;
                }
                continue;
            } else {
                partial_packet.push(b);
            }
            i++;
        }
    }
}

const pool = new BufferPool();

class Serialport {

    constructor(port) {
        this.recevie = false;
        this.inst = port;
        this.isOpen = true;
        this.inst.on('data', (data) => {
            this.recevie = true;
            console.log('-> read by serialport', data);
            pool.write(data);
        });
        this.inst.on('disconnect', () => {
            this.isOpen = false;
        });
    }

    write(buf) {
        this.recevie = false;
        if (!this.isOpen) {
            throw new Error('serialport is diconnect');
        }
        pool.buf = [];  // 清空之前的数据包
        this.inst.write(buf, 'utf8', () => {
        });
    }
}

class Esp {
    /**
     *
     * @param serialPort
     * @param data
     * @param progressHandle 封装的进度回调
     * @param progresscb   源进度回调，用于执行封装回调时传入，避免外层取this作用域有变无法取到
     * @param tag      当前烧录固件请求ID
     */
    constructor(serialPort, data, progressHandle, progresscb, tag) {
        this.firmwareDataBuffer = Buffer.from(data);
        this.progressHandle = progressHandle;
        this.progresscb = progresscb;
        this._port = serialPort;
        this.tag = tag;
        this.initEsp();
        console.warn('wait write data', this.firmwareDataBuffer);
    }

    initEsp() {
        this.flash_size = FLASH_SIZE;
        this.addrIdx = 0x1000;
        this.flash_mode = 'dio';
        this.flash_freq = 'keep';
        this.compress = true;
        this.flashingGo = false;
        this.STATUS_BYTES_LENGTH = 4;
        this.IS_STUB = false;
        this._port.inst.set({rts: true, dtr: true});
    }

    pad_to(data, alignment, pad_character = 0xFF) {
        const pad_mod = data.length % alignment;
        if (pad_mod !== 0) {
            let pad = [];
            for (let i = 0; i < (alignment - pad_mod); i++) {
                pad.push(pad_character);
            }
            data = Buffer.concat([data, Buffer.from(pad)]);
        }
        return data;
    }

    _update_image_flash_params(address, args, image) {
        if (image.length < 8) {
            return image;
        }
        let [magic, _, flash_mode, flash_size_freq] = new Packer('BBBB').unpack(image.slice(0, 4));
        if ((address !== ESP32ROM.BOOTLOADER_FLASH_OFFSET) || (magic !== ESP_IMAGE_MAGIC)) {
            return image;
        }
        if (args.flash_mode !== 'keep') {
            flash_mode = {'qio': 0, 'qout': 1, 'dio': 2, 'dout': 3}[args.flash_mode];
        }
        let flash_freq = flash_size_freq & 0x0F;
        if (args.flash_freq !== 'keep') {
            flash_freq = {'40m': 0, '26m': 1, '20m': 2, '80m': 0xf}[args.flash_freq];
        }
        let flash_size = flash_size_freq & 0xF0;
        if (args.flash_size !== 'keep') {
            flash_size = ESP32ROM.FLASH_SIZES[args.flash_size];
        }
        const flash_params = new Packer('BB').pack(flash_mode, flash_size + flash_freq);
        if (0 !== flash_params.compare(image.slice(2, 4))) {
            image = Buffer.concat([image.slice(0, 2), flash_params, image.slice(4)]);
        }
        return image;
    }

    async flash_defl_begin(size, compsize, offset) {
        const num_blocks = parseInt((compsize + FLASH_WRITE_SIZE - 1) / FLASH_WRITE_SIZE);
        const erase_blocks = parseInt((size + FLASH_WRITE_SIZE - 1) / FLASH_WRITE_SIZE);
        const t = new Date().getTime();
        let write_size, timeout;
        if (this.IS_STUB) {
            write_size = size;
            timeout = DEFAULT_TIMEOUT;
        } else {
            write_size = erase_blocks * FLASH_WRITE_SIZE;
            timeout = this.timeout_per_mb(ERASE_REGION_TIMEOUT_PER_MB, write_size);
        }

        await this.check_command('enter compressed flash mode', ESP_FLASH_DEFL_BEGIN,
            new Packer('<IIII').pack(write_size, num_blocks, FLASH_WRITE_SIZE, offset),
            0, timeout);

        return num_blocks;
    }

    async check_command(op_description, op = null, data = [], chk = 0, timeout = DEFAULT_TIMEOUT) {
        console.warn(op_description);
        let [val, d] = await this.command(op, data, chk, timeout);
        if (d.length < this.STATUS_BYTES_LENGTH) {
            throw new Error(`Failed to ${op_description}. Only got ${d.length} byte status response.`);
        }
        const status_bytes = d.slice(d.length - this.STATUS_BYTES_LENGTH);
        if (status_bytes.slice(0, 1).toString('hex') !== '00') {
            throw new Error(`Failed to ${op_description}`);
        }

        if (d.length > this.STATUS_BYTES_LENGTH) {
            return d.slice(0, d.length - this.STATUS_BYTES_LENGTH);
        } else {
            return val;
        }
    }

    read_from_pool(op, timeout) {
        let num = 0;
        return new Promise(resolve => {
            const readPoolItem = setInterval(() => {
                let p = pool.read();
                if (0 === p.length) {
                    num++;
                }
                if (timeout * 10 < num) {
                    clearInterval(readPoolItem);
                    resolve(false);
                    return;
                }
                try {
                    let [resp, op_ret, len_ret, val] = new Packer('<BBHI').unpack(p.slice(0, 8));
                    let databuf = p.slice(8);
                    if (op === null || op_ret === op) {
                        clearInterval(readPoolItem);
                        resolve([val, databuf]);
                    }
                } catch (e) {

                }
            }, 100);
        });
    }

    async command(op = null, data, chk = 0, timeout = DEFAULT_TIMEOUT) {
        if (op !== null) {
            const pkt = Buffer.concat([new Packer('<BBHI').pack(0x00, op, data.length, chk), data]);
            await this.write(pkt);
        }
        const rst = await this.read_from_pool(op, timeout);

        if (false !== rst) {
            return rst;
        }

        throw new Error('Response doesn\'t match request');
    }

    async write(packet) {
        let buf = [0xc0];
        packet.forEach((v, k) => {
            if (v === 0xdb) {
                buf.push(0xdb);
                buf.push(0xdd);
            } else if (v === 0xc0) {
                buf.push(0xdb);
                buf.push(0xdc);
            } else {
                buf.push(v);
            }
        });
        buf.push(0xc0);
        console.log('<-write to serialport', buf);
        await this._port.inst.drain();
        this._port.write(buf);
        return new Promise(resolve => {
            const t = new Date().getTime();
            const loop = setInterval(() => {
                if (this._port.recevie) {
                    clearInterval(loop);
                    resolve();
                } else if (2000 < (new Date().getTime() - t)) {
                    clearInterval(loop);
                    resolve();
                }
            }, 100);
        });
    }

    timeout_per_mb(seconds_per_mb, size_bytes) {
        const result = seconds_per_mb * (size_bytes / 1e6);
        if (result < DEFAULT_TIMEOUT) {
            return DEFAULT_TIMEOUT;
        }
        return result;
    }

    checksum(data, state = ESP_CHECKSUM_MAGIC) {
        data.forEach((v, k) => {
            if (typeof(v) === 'number') {
                state ^= v;
            } else {
                state ^= v.charCodeAt();
            }
        });
        return state;
    }

    async flash_defl_block(data, seq, timeout = DEFAULT_TIMEOUT) {
        await this.check_command(`write compressed data to flash after seq ${seq}`,
            ESP_FLASH_DEFL_DATA, Buffer.concat([new Packer('<IIII').pack(data.length, seq, 0, 0), data]), this.checksum(data), timeout);
    }

    async flash_md5sum(addr, size) {
        const timeout = this.timeout_per_mb(MD5_TIMEOUT_PER_MB, size);
        let res = await this.check_command('calculate md5sum', ESP_SPI_FLASH_MD5, new Packer('<IIII').pack(addr, size, 0, 0), 0, timeout);
        if (res.length === 32) {
            return res.toString('utf8');
        } else if (res.length === 16) {
            return res.toString('hex').toLowerCase();
        } else {
            throw new Error(`MD5Sum command returned unexpected result: ${res.toString()}`);
        }
    }

    async flash_defl_finish(reboot = false) {
        const pkt = new Packer('<I').pack(Number(!reboot));
        await this.check_command('leave compressed flash mode', ESP_FLASH_DEFL_END, pkt);
    }

    async flash_begin(size, offset) {
        const num_blocks = parseInt((size + FLASH_WRITE_SIZE - 1) / FLASH_WRITE_SIZE);
        const erase_size = this.get_erase_size(offset, size);
        await this.check_command('enter Flash download mode', ESP_FLASH_BEGIN,
            new Packer('<IIII').pack(erase_size, num_blocks, FLASH_WRITE_SIZE, offset),
            0, DEFAULT_TIMEOUT);
    }

    get_erase_size(offset, size) {
        return size;
    }

    async mem_begin(size, blocks, blocksize, offset) {
        return await this.check_command('enter RAM download mode', ESP_MEM_BEGIN, new Packer('<IIII').pack(size, blocks, blocksize, offset));
    }

    async mem_block(data, seq) {
        return await this.check_command('write to target RAM', ESP_MEM_DATA, Buffer.concat([new Packer('<IIII').pack(data.length, seq, 0, 0), data]), this.checksum(data));
    }

    async mem_finish(entrypoint = 0) {
        const data = new Packer('<II').pack(Number(entrypoint === 0), entrypoint);
        try {
            return await this.check_command('leave RAM download mode', ESP_MEM_END, data, 0, DEFAULT_TIMEOUT);
        } catch (e) {
            if (this.IS_STUB) {
                throw e;
            }
            return;
        }
    }

    async run_stub() {
        const stub = ESP32ROM.STUB_CODE;
        for (let field of ['text', 'data']) {
            if (stub[field]) {
                let offs = stub[field + '_start'];
                let length = stub[field].length;
                let blocks = parseInt((length + ESP_RAM_BLOCK - 1) / ESP_RAM_BLOCK);
                await this.mem_begin(length, blocks, ESP_RAM_BLOCK, offs);
                for (let seq = 0; seq < blocks; seq++) {
                    let from_offs = seq * ESP_RAM_BLOCK;
                    let to_offs = from_offs + ESP_RAM_BLOCK;
                    to_offs = (to_offs > stub[field].length) ? stub[field].length : to_offs;
                    await this.mem_block(stub[field].slice(from_offs, to_offs), seq);
                }
            }
        }
        await this.mem_finish(stub['entry']);

        let p = pool.read();
        if ('OHAI' !== p.toString()) {
            throw new Error(`Failed to start stub. Unexpected response: ${p.toString()}`);
        }
        return this.IS_STUB = true;
    }

    async _connect_attempt(mode = 'default_reset_connect_attempt', esp32r0_delay = false) {
        if (!this._port.isOpen) {
            throw new Error('serialport is diconnect');
        }

        let last_error = null;
        if (mode === 'no_reset_no_sync') {
            return last_error;
        }
        if (mode !== 'no_reset') {
            this._port.inst.set({dtr: false, rts: true});
            await this.sleep(0.1);
            if (esp32r0_delay) {
                await this.sleep(1.2);
            }
            this._port.inst.set({dtr: true, rts: false});
            if (esp32r0_delay) {
                await this.sleep(0.4);
            }
            await this.sleep(0.05);
            this._port.inst.set({dtr: false, rts: false});
        }

        for (let i = 0; i < 5; i++) {
            try {
                await this._port.inst.drain();
                await this.sync();
                return null;
            } catch (e) {
                await this.sleep(0.05);
                last_error = e;
            }
        }

        return last_error;

    }

    async sync() {
        let bs = [0x07, 0x07, 0x12, 0x20];
        for (let i = 0; i < 32; i++) {
            bs.push(0x55);
        }
        const b = Buffer.from(bs);
        await this.command(ESP_SYNC, b, 0, SYNC_TIMEOUT);
        for (let i = 0; i < 7; i++) {
            await this.command();
        }
    }

    sleep(s) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, s * 1000);
        });
    }

    async connect(mode = 'default_reset') {
        let last_error;
        try {
            for (let i = 0; i < 7; i++) {
                last_error = await this._connect_attempt(mode, false);
                if (last_error === null) {
                    return;
                }
                last_error = await this._connect_attempt(mode, true);
                if (last_error === null) {
                    return;
                }
            }
        } catch (e) {

        }
        throw new Error('Failed to Boot.');
    }

    async hard_reset() {
        this._port.inst.set({rts: true, dtr: false});
        await this.sleep(0.1);
        this._port.inst.set({rts: false, dtr: false});
    }

    async write_flash() {
        let args = {};
        args.flash_size = this.flash_size;
        args.flash_mode = this.flash_mode;
        args.flash_freq = this.flash_freq;
        args.compress = this.compress;

        await this.connect('default_reset');

        const flash_end = Flash_Size_Bytes(args.flash_size);
        const address = parseInt(this.addrIdx, 10);
        if (flash_end < (address + this.firmwareDataBuffer.length)) {
            throw new Error(`Firmware (length ${this.firmwareDataBuffer.length}) at offset ${address} will not fit in ${flash_end} bytes of flash. Use --flash-size argument, or change flashing address.`)
        }
        let image = this.pad_to(this.firmwareDataBuffer, 4);

        image = this._update_image_flash_params(address, args, image);
        const calcmd5 = crypto.createHash('md5').update(image).digest('hex');
        const uncsize = image.length;

        await this.run_stub();

        this.flashingGo = true;
        const uncimage = image;
        image = zlib.deflateSync(uncimage, {level: 9});
        let ratio = uncsize / image.length;

        this.STATUS_BYTES_LENGTH = 2;

        let blocks = await this.flash_defl_begin(uncsize, image.length, address);

        let seq = 0, block, per = 0;
        let written = 0;
        let t = new Date().getTime();
        while (image.length > 0) {
            per = parseInt(100 * (seq + 1) / blocks);
            console.warn(`Writing at ... (${per} %)`);
            if (per < 100) {
                this.progressHandle(this.tag, this.progresscb, per);
            }
            block = image.slice(0, FLASH_WRITE_SIZE);
            await this.flash_defl_block(block, seq, DEFAULT_TIMEOUT * ratio);
            image = image.slice(FLASH_WRITE_SIZE);
            seq += 1;
            written += block.length;
        }
        t = new Date().getTime() - t;
        console.log('烧录总耗时: ', t + ' ms');

        const res = await this.flash_md5sum(address, uncsize);
        if (res !== calcmd5) {
            throw new Error('MD5 of file does not match data in flash!');
        }

        await this.flash_begin(0, 0);
        await this.flash_defl_finish(false);
        await this.hard_reset();
        this.progressHandle(this.tag, this.progresscb, 100);
    }
}

class Esptool {
    /**
     * 初始化示例
     * @param serialPort
     * @param data
     * @param progressHandle 封装的进度回调
     * @param progresscb   源进度回调，用于执行封装回调时传入，避免外层取this作用域有变无法取到
     * @param current      当前烧录固件请求ID
     */
    constructor(serialPort, data, progressHandle, progresscb, current) {
        const serial = new Serialport(serialPort);
        this.currentTag = current;
        this.esptool = new Esp(serial, data, progressHandle, progresscb, current);
    }

    /**
     * 烧录执行
     * @param callbackHandle 封装callback回调
     * @param callback  源callback回调，用于执行封装回调时传入，避免外层取this作用域有变无法取到
     * @returns {Promise<void>}
     */
    async bootLoad(callbackHandle, callback) {
        try {
            pool.init();
            this.esptool.initEsp();
            await this.esptool.write_flash();
            callbackHandle(this.currentTag, callback, null, () => {
            });
        } catch (e) {
            callbackHandle(this.currentTag, callback, e, null);
            console.log(e.message);
        }
    }
}


export default Esptool;